import ConfigurableTable from 'components/shared/table/ConfigurableTable';

import GNESearch from 'components/shared/search/GNESearch';
import { Spinner } from 'components/shared/loader/Spinner';
import { useEffect, useState } from 'react';
import { Col, Row, Tooltip } from 'react-bootstrap';

import LinkButton from 'components/shared/button/LinkButton';
import { ReactSelect } from 'components/shared/dropdown/GNESingleSelect';
import {
  areas,
  CONFIGURE_VIEW,
  DATE_FORMAT,
  TABLE_VIEWS_COLUMNS,
  INSIGHT_TYPE_CODE,
} from 'constants/constants';
import moment from 'moment';
import { Fade } from 'react-awesome-reveal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  setCards,
  setDefaultCard,
  setSelectedView,
} from 'store/home/homeMyViewSlice';
import classes from './ViewLayout.module.scss';

import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import { getUserViewsData } from 'components/shared/views/services/user-view.service';
import ViewActions from 'components/shared/views/view-actions/ViewActions';
import { usePromiseTracker } from 'react-promise-tracker';
import { getImpactedCardsData } from 'store/home/home-my-view-actions';
import { searchData } from 'utils/utils';
import TileImpactWarning from '../TileImpactWarning';
import WarningOnHomeMyView from '../WarningOnHomeMyView';

const ViewLayout = ({ page }) => {
  const isMyView = page === CONFIGURE_VIEW.myDefault ? false : true;
  const { allMViews, allDViews } = useSelector((state) => state?.HomeMyView);
  const [viewRows, setViewRows] = useState([]);
  const [searchText, setSearchText] = useState('');
  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);
  const [modalShow, setModalShow] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentViewRecord, setCurrentViewRecord] = useState();
  const [showGlobalwarning, setShowGlobalwarning] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const impactedCards = useSelector(
    (state) => state?.HomeMyView?.impactedCards
  );
  const { promiseInProgress: loadingViews } = usePromiseTracker({
    area: areas.userView,
  });

  const dispatch = useDispatch();

  const navigateTo = useNavigate();

  useEffect(() => {
    if (isMyView) {
      dispatch(getUserViewsData(roleId, unixId, INSIGHT_TYPE_CODE.GENERAL));
    }
    if (!isMyView) {
      dispatch(getUserViewsData(roleId, unixId, INSIGHT_TYPE_CODE.SAMPLE));
    }
    dispatch(getImpactedCardsData(unixId, roleId));
  }, []);

  useEffect(() => {
    if (isMyView) {
      setViewRows(allMViews);
    } else if (!isMyView) {
      setViewRows(allDViews);
    }
  }, [allMViews, allDViews, page]);

  useEffect(() => {
    setShowGlobalwarning(impactedCards?.some((card) => card.isActive === 'Y'));
  }, [impactedCards]);

  const filterViewOptions = [
    { value: 'All Views', label: 'All Views' },
    { value: 'Created By Me', label: 'Created By Me' },
    { value: 'Shared With Me', label: 'Shared With Me' },
  ];

  const handleSearch = (value) => {
    const filteredData = searchData(!isMyView ? allDViews : allMViews, value);
    setSearchText(value);
    setViewRows(filteredData);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  const onViewFilterChange = (value) => {
    return value;
  };

  const sortData = () => {};
  const size = { x: 800 };
  const tooltip = () => {
    return (
      <Tooltip className='gne-tooltip'>
        <span className='text text__x-small'>
          If you’d like to submit your view for availability to C360 users,
          please submit a ticket by clicking the Help button at the top right
          and selecting "Raise Request." We will get in touch with you and
          assist in publishing it as a sample view.
        </span>
      </Tooltip>
    );
  };

  const handleViewClick = (rowData, index) => {
    dispatch(setDefaultCard([]));
    dispatch(setCards([]));
    dispatch(setSelectedView(rowData));
    navigateTo(`/view/${!isMyView ? 'sampleview' : 'myview'}/${rowData?.Id}`);
  };

  const viewActionHandler = (record, e) => {
    setCurrentViewRecord(record);
    setAnchorEl(e.currentTarget);
  };

  return (
    <>
      {showGlobalwarning && isMyView && (
        <Fade>
          <TileImpactWarning
            showConfirmation={showConfirmation}
            setShowConfirmation={setShowConfirmation}
            setShowGlobalwarning={setShowGlobalwarning}
          />
        </Fade>
      )}
      <Row className='align-items-center mt-3 display-flex justify-content-between'>
        <Col
          sm={4}
          className='ps-0'>
          {((isMyView && allMViews?.length > 0) ||
            (!isMyView && allDViews?.length > 0)) && (
            <GNESearch
              placeholder={`Search by Name, ${
                isMyView ? 'Owner' : 'Publisher'
              } or Role`}
              onSearch={handleSearch}
              value={searchText}
              onChange={handleSearchChange}
              className='text text__small'
              onClear={handleSearch}
            />
          )}
        </Col>

        <Col
          sm={6}
          className='d-flex justify-content-end pe-0'>
          {isMyView ? (
            <>
              {viewRows?.length > 0 && (
                <div className='pe-3'>
                  <ReactSelect
                    placeholder={'All Views'}
                    onChange={onViewFilterChange}
                    options={filterViewOptions}
                    className='single-select text text__small'
                    isDisabled={true}
                  />
                </div>
              )}
              <LinkButton onClick={() => setModalShow(true)}>
                <span className={classes.addViewBtnText}>
                  <i className='icon icon__add' /> Add New View
                </span>
              </LinkButton>
            </>
          ) : (
            <div>
              <OverlayTrigger overlay={tooltip()}>
                <i className={`icon icon__info_icon-yellow`} />
              </OverlayTrigger>
              <span className='text text__bold text__small mb-4 '>
                Submit Your Views
              </span>
            </div>
          )}
        </Col>
      </Row>
      {loadingViews && <Spinner area={areas.userView} />}
      {((isMyView && allMViews?.length > 0) ||
        (!isMyView && allDViews?.length > 0)) && (
        <ConfigurableTable
          rows={viewRows}
          columns={TABLE_VIEWS_COLUMNS.map((col) => {
            if (col.dataIndex === 'name') {
              return {
                ...col,
                render: (text, record) => (
                  <div
                    className='span-link text text__normal text__bold'
                    onClick={() => handleViewClick(record)}>
                    {text && text.length > 37 ? (
                      <OverlayTrigger
                        overlay={
                          <Tooltip className='gne-tooltip'>{text}</Tooltip>
                        }>
                        <span>{text.substring(0, 37) + '...'}</span>
                      </OverlayTrigger>
                    ) : (
                      <span className='text text__normal text__bold'>
                        {text}
                      </span>
                    )}
                  </div>
                ),
              };
            }
            if (col.dataIndex === 'owner') {
              return {
                ...col,
                render: (text, record) => (
                  <div>
                    <span className='text'>{text}</span>
                  </div>
                ),
                title: isMyView ? 'Owner' : 'Publisher',
              };
            }
            if (col.dataIndex === 'createdDate') {
              return {
                ...col,
                render: (_, record) => (
                  <div className='text'>
                    <OverlayTrigger
                      overlay={
                        <Tooltip className='gne-tooltip'>
                          {record.category === 'created'
                            ? 'Created Date'
                            : 'Shared Date'}
                        </Tooltip>
                      }>
                      <span>
                        {moment(record.createdDate).format(DATE_FORMAT)}
                      </span>
                    </OverlayTrigger>
                  </div>
                ),
              };
            }

            return col;
          })}
          expandRowByClick={false}
          enableColumnSelection={false}
          tableName='myViews'
          showActionIcon={true}
          onActionClickHandler={viewActionHandler}
          iconProps={{
            iconCss: 'card-toggle',
          }}
          pagination={false}
          isGlobalSort={true}
          onSort={sortData}
          dimentions={size}
          actionColumnTitle='Actions'
        />
      )}

      <Fade>
        {!loadingViews &&
          page === CONFIGURE_VIEW.myView &&
          allMViews?.length === 0 && (
            <h3 className={classes.defaultMessage}>
              Click on {''}
              <span
                onClick={() => setModalShow(true)}
                className='title__blue pointer'>
                Add New View
              </span>{' '}
              to begin
            </h3>
          )}
        {page === CONFIGURE_VIEW.myView && (
          <div className={classes['disclaimer-text']}>
            Disclaimer:
            <em>
              This information is shared for transparency and coordination. Not
              all information is necessary or appropriate for all roles; focus
              on information that is critical for your role and only use data
              consistent with your role description and within the HCO policies,
              procedures, and business guidance applicable to your role.
            </em>
          </div>
        )}
      </Fade>
      <WarningOnHomeMyView
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        setShowGlobalwarning={setShowGlobalwarning}
      />
      <ViewActions
        page={page}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        currentViewRecord={currentViewRecord}
        viewModalShow={modalShow}
        setViewModalShow={setModalShow}
      />
    </>
  );
};

export default ViewLayout;
